module.exports = __webpack_public_path__ + "static/media/muscu_sante_2.a681035f.jpg";